import { containsAnyIgnoreCase } from '@dte/otw-utils-core/src/strings/equalsIgnoreCase';
import { type WireIssue, WirePosition } from '../../../interfaces/api/CustomerReport';

export function isWireDownOrWithinReach(wireIssue: WireIssue | undefined): wireIssue is WireIssue {
	return containsAnyIgnoreCase([WirePosition.Down, WirePosition.WithinReach], wireIssue?.position);
}
